export default __webpack_public_path__ + "static/media/video-call.ad52695e.svg";